import { getCurrentInstance } from "vue";
import { zip, strToU8 } from 'fflate';

export default class ServiceVistraAI {
  private http: any;
  private $vistra: any;

  constructor() {
    const app = getCurrentInstance();
    this.$vistra = app!?.appContext.config.globalProperties.$vistra;
    this.http = app!?.appContext?.config?.globalProperties?.$http;
  }

  public async enviarPrompt(
    prompt: string,
    dataSource: any,
    historico: any,
    campos: any,
    key: string,
    metaData: object
  ): Promise<any> {

    let cacheExistsResponse = await this.http.get(`LlmHandler/CacheKeyExists/${key}`);
    let cacheNaoExiste = !cacheExistsResponse?.data?.data?.cached;

    if (cacheNaoExiste){
      let formDataComArquivos: FormData | undefined =
          await this.montarFormDataComArquivoZip(
              dataSource,
              campos,
              key
          );

      await this.http.post(`LlmHandler/SendFiles`, formDataComArquivos);
    }

    return await this.analiseComCache(prompt, key, historico, metaData);
  }

  private async analiseComCache(prompt: string, key: string, historico: any, metaData: object): Promise<any> {
    const response = await this.http.post(`LlmHandler/ExecutarAnaliseIA`, {
      textoUsuario: prompt,
      historico: historico,
      key: key,
      metaData: metaData
    });

    return response?.data;
  }

  public async gerarPerguntas(
    fontesDadosCompactadas: any,
    campos: any,
    key: string,
    metaData: object
  ): Promise<any> {
    // Converter os dados para strings e em seguida para U8 arrays
    const zipFonteDadosInput = { "fontedados.json": strToU8(JSON.stringify(fontesDadosCompactadas)) };

    // Zipando os dados com nível de compressão (0-9)
    const fontedadosBlob: string | Blob = await new Promise((resolve) => {
      zip(zipFonteDadosInput, { level: 9 }, (err, data) => resolve(new Blob([data])));
    });

    // Zipando os campos
    const zipCamposInput = this.montarZipCampos(campos);  // Substitua pela sua função
    const camposBlob: string | Blob = await new Promise((resolve) => {
      zip(zipCamposInput, { level: 9 }, (err, data) => resolve(new Blob([data])));
    });

    //Criando e enviando formData
    let formData = new FormData();
    formData.append("DataSource", fontedadosBlob);
    formData.append("dataStructure", camposBlob);
    formData.append("key", key);
    formData.append("storageType", "NativeStorage");

    let responseCache = await this.http.post(`LlmHandler/SendFiles`, formData);

    if (!responseCache.data.cached)
      console.error("Error caching files", responseCache?.data);

    let response = await this.http.post(`LlmHandler/GerarPerguntasIA`, { key: key, metaData: metaData });

    return response.data;
  }

  private async montarFormDataComArquivoZip(
    fontesDadosCompactadas: any,
    campos: any,
    key: string
  ) {
    try {
      // Converter os dados para strings e em seguida para U8 arrays
      const zipFonteDadosInput = { "fontedados.json": strToU8(JSON.stringify(fontesDadosCompactadas)) };

      // Zipando os dados com nível de compressão (0-9)
      const fontedadosBlob: string | Blob = await new Promise((resolve) => {
        zip(zipFonteDadosInput, { level: 9 }, (err, data) => resolve(new Blob([data])));
      });
      // Zipando os campos
      const zipCamposInput = this.montarZipCampos(campos);  // Substitua pela sua função
      const camposBlob: string | Blob = await new Promise((resolve) => {
        zip(zipCamposInput, { level: 9 }, (err, data) => resolve(new Blob([data])));
      });

      //Criando e enviando formData
      let formData = new FormData();

      formData.append("dataSource", fontedadosBlob);
      formData.append("dataStructure", camposBlob);
      formData.append("key", key);

      return formData;
    } catch (error) {
      console.error("Error zipping the dataset:", error);
    }
  }

  private montarZipCampos(campos: any) {

    const camposMapeados = campos.map((item: any) => ({
      campo: item.campo,
      tipo: item.tipo,
      titulo: item.titulo,
    }));

    return { "fontedados.json": strToU8(JSON.stringify(camposMapeados)) };
  }
}
